import React, { useEffect, useState } from "react";
import {
  GstrOneAutoFilledTable,
  GstrOneTable,
} from "../../../../components/Gst";
import { connect } from "react-redux";
import { RootState } from "../../../../redux/rootReducers";
import Select, { StylesConfig } from "react-select";
import {
  CommonHeader,
  ErrorSuccessModal,
  Loader,
} from "../../../../components/commons";
import {
  Button,
  ButtonDropdown,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import RenderHeaderCard from "../../../../components/commons/ContentArea/RenderHeaderCard";
import "../../styles.scss";
import { NewDownloadIconActive } from "../../../../assets/images";
import GstrThreeBAutoFilledTable from "../../../../components/Gst/GstrForms/GstrThreeBTable/GstrThreeAutoFilledTable";
import GstrThreeBTable from "../../../../components/Gst/GstrForms/GstrThreeBTable";
import { OptionsType } from "../../../../commonTypes/universalTypes";
import {
  finacialYear,
  finacialYearMonth,
} from "../../../../components/commons/Gst";
import { TableHeadersType } from "../../../../constant/tableHeadersConstants/tableHeadersType";
import { GetAllBussinessAddressesListPayloadType } from "../../../../commonTypes/clientSettingsTypes";
import {
  getAllBusinessAddressAction,
  resetBusinessAddressList,
} from "../../../../redux/clientSettings";
import {
  ApproveGstPayloadType,
  GetGstNumberPayload,
  GetGstrThreeBListPayloadType,
  GstCommentPayloadType,
  GstGetAllCommentPayloadType,
  GstNumberType,
  GstrThreeBDataType,
  GstrThreeBInvoiceListPayload,
} from "../../../../commonTypes/gstTypes";
import {
  approveGstAction,
  getGstNumberList,
  getGstThreebInvoiceListAction,
  getGstrThreeBListAction,
  gstGetAllCommentAction,
  gstPostCommentAction,
  resetGstCommentsSuccess,
  resetGstMessage,
  resetGstModuleError,
  resetGstModuleSuccess,
  resetGstNumberList,
  resetGstrThreeBDataList,
  resetGstrThreeBInvoiceList,
} from "../../../../redux/gstModule";
import { useParams } from "react-router-dom";
import { resetSession } from "../../../../redux/auth";
import { MyContext } from "./ContextApi";
import Approve from "../../../../components/commons/ApprovalModule/Approve";
import CommentModal from "../../../../components/commons/CommentModal/CommentModal";
import {
  checkSameUserId,
  getMonthNumber,
} from "../../../../utils/commonFunctions";
import { components } from "react-select";
import { LoginResponseType } from "../../../../redux/auth/authTypes";
import toast from "react-hot-toast";
import { useMenuCheck } from "../../../../customHooks/useMenuCheck";
const customStyles: StylesConfig<any, false> = {
  control: (provided: any) => ({
    ...provided,
    cursor: "pointer",
  }),

  option: (provided: any) => ({
    ...provided,
    cursor: "pointer",
  }),
};

type AppProps = {
  history: any;
  token: string | null;
  branch: any | null;
  success: number | null;
  error: string | null | undefined;
  statusCode: number | null;
  fetching: boolean;
  message: string | null;
  gstrThreeBData: GstrThreeBDataType | any;
  gstrThreeBInvoiceList: any;
  dispatchResetGstrThreeBInvoiceList: () => void;
  dispatchGetGstThreebInvoiceListAction: (
    data: GstrThreeBInvoiceListPayload
  ) => void;
  dispatchGetAllBusinessAddressAction: (
    data: GetAllBussinessAddressesListPayloadType
  ) => void;
  dispatchGetGstrThreeBListAction: (data: GetGstrThreeBListPayloadType) => void;
  dispatchResetGstrThreeBDataList: () => void;
  dispatchResetBusinessAddressList: () => void;
  dispatchResetGstModuleSuccess: () => void;
  dispatchResetGstModuleError: () => void;
  dispatchResetSession: () => void;
  dispatchApproveGst: (data: ApproveGstPayloadType) => void;
  dispatchPostGstCommentsAction: (data: GstCommentPayloadType) => void;
  gstCommentSuccess: null | number;
  dispatchResetCommentsSuccess: () => void;
  dispatchGetAllGstCommentsAction: (data: GstGetAllCommentPayloadType) => void;
  gstCommentData: any;
  gstNumberList: GstNumberType[] | [];
  dispatchGetGstNumber: (data: GetGstNumberPayload) => void;
  loginData: LoginResponseType;
  dispatchResetMessage: () => void;
};
const GstrThreeB = ({
  token,
  history,
  branch,
  fetching,
  success,
  error,
  statusCode,
  message,
  gstrThreeBData,
  gstrThreeBInvoiceList,
  dispatchResetGstrThreeBInvoiceList,
  dispatchGetGstThreebInvoiceListAction,
  dispatchGetAllBusinessAddressAction,
  dispatchGetGstrThreeBListAction,
  dispatchResetGstrThreeBDataList,
  dispatchResetBusinessAddressList,
  dispatchResetGstModuleSuccess,
  dispatchResetGstModuleError,
  dispatchResetSession,
  dispatchApproveGst,
  gstCommentSuccess,
  dispatchResetCommentsSuccess,
  dispatchGetAllGstCommentsAction,
  dispatchPostGstCommentsAction,
  gstCommentData,
  gstNumberList,
  dispatchGetGstNumber,
  loginData,
  dispatchResetMessage,
}: AppProps) => {
  const params: any = useParams();
  const [toggle, setToggle] = useState<boolean>(false);
  const [collapseAccordian, setCollapseAccordian] = useState<boolean>(false);
  const [branchList, setBranchList] = useState<any>([]);
  const [financialYear, setFinancialYear] = useState<OptionsType>({
    value: "",
    label: "Select Fy",
  });
  const [month, setMonth] = useState<OptionsType>({ value: "", label: "" });
  const [branchSelected, setBranchSelected] = useState<OptionsType>({
    value: "",
    label: "Select Branch",
  });
  const [gstNoList, setGstNoList] = useState<any>([]);
  const [gstrOneInvoiceData, setGstrOneInvoiceData] = useState<any>({});
  const finacialYearOptions = finacialYear(2017);
  const financialStartYear = financialYear?.label.split("-")[0]?.slice(2, 4);
  const financialEndYear = financialYear?.label.split("-")[1];
  const getMonthsOptions: TableHeadersType[] = finacialYearMonth(
    financialStartYear,
    "Apr",
    +financialEndYear
  )?.map((e: TableHeadersType) => {
    return {
      label: e.label,
      value: e.value,
    };
  });
  const [gstrThreeBInvoiceData, setGstrThreeBInvoiceData] = useState<any>({});
  const [gstNo, setGstNo] = useState<OptionsType>({
    value: "",
    label: "Select GST No.",
  });
  const [approved, setApproved] = useState<boolean>(false);
  const [showGstCommentsModal, setShowGstCommentsModal] =
    useState<boolean>(false);
  const [commentData, setCommentData] = useState<any>(null); //comment model data
  const [isApprovalPresent, setIsApprovalPresent] = useMenuCheck();
  const [isCommentPresent, setIsCommentPresent] = useMenuCheck();
  const [isGstFillingPresent, setIsGstFillingPresent] = useMenuCheck();

  const company_name: string = history?.location?.state?.company_name
    ? history?.location?.state?.company_name
    : localStorage.getItem("company_name");

  useEffect(() => {
    window.scroll({
      top: 0,
      left: 0,
    });
    setIsGstFillingPresent("GSTR-ThreeB Filing", "menu");
    setIsCommentPresent("GSTR-ThreeB Comment", "menu");
    setIsApprovalPresent("GSTR-ThreeB Approval", "menu");
    resetData();
    dispatchResetGstrThreeBDataList();
    dispatchResetBusinessAddressList();
    dispatchResetGstModuleSuccess();
    dispatchResetGstModuleError();
    dispatchResetGstrThreeBInvoiceList();
    const getFinancialYear = finacialYear(2017);
    if (getFinancialYear?.length > 0) {
      setFinancialYear(getFinancialYear[getFinancialYear?.length - 1]);
    }

    if (token) {
      let data = {
        token,
        client_code: params?.id,
      };
      dispatchGetAllBusinessAddressAction(data);
      dispatchGetGstNumber(data);
    }
  }, []);

  useEffect(() => {
    if (showGstCommentsModal) {
      if (financialYear) {
        let monthData = month?.value?.split("-")?.[0];
        const finalData = {
          client_code: params?.id,
          gstin: gstNo?.value,
          financial_year: financialYear?.value,
          month: `0${
            getMonthNumber(monthData) === 0 ? "" : getMonthNumber(monthData)
          }`,
          gst_form_type: "GSTR3b",
          token,
        };
        dispatchGetAllGstCommentsAction(finalData);
      }
    }
  }, [showGstCommentsModal]);

  useEffect(() => {
    let newData = branch?.map((item: any) => {
      return {
        label: item?.trade_name,
        value: item?.ledger_id,
        gstIn: item?.gst_number,
        legalName: item?.legal_name,
      };
    });
    setBranchList([...newData]);
  }, [branch]);

  useEffect(() => {
    if (financialYear) {
      setMonth({
        value: `Apr-${financialStartYear}`,
        label: `Apr-${financialStartYear}`,
      });
    }
  }, [financialYear]);

  useEffect(() => {
    if ((branchSelected?.value || gstNo?.value) && token) {
      dispatchResetGstrThreeBDataList();
      const finalData = {
        token,
        clientCode: params?.id,
        branchId: branchSelected?.value,
        month: !!month.value ? month?.value : `Apr-${financialStartYear}`,
        gst_form_type: "GSTR3b",
        gstin: gstNo?.value,
        gst_number: gstNo?.value,
      };
      branchSelected?.value
        ? delete finalData?.gst_number
        : delete finalData?.branchId;
      setCollapseAccordian(!collapseAccordian);
      dispatchGetGstrThreeBListAction(finalData);
      setGstrThreeBInvoiceData({});
    }
  }, [branchSelected, month.value, financialYear.value, gstNo]);

  useEffect(() => {
    if (
      loginData?.user_id ||
      gstrThreeBData?.approval_details?.approval_details?.length > 0
    ) {
      let user_id;

      if (loginData?.user_id) {
        user_id = checkSameUserId(
          loginData?.user_id,
          gstrThreeBData?.approval_details?.approval_details
        );
      }
      let totelArrpovedData =
        gstrThreeBData?.approval_details?.approval_details?.length === 3;
      setApproved(user_id || totelArrpovedData);
    }
  }, [loginData?.user_id, gstrThreeBData?.approval_details]);

  useEffect(() => {
    if (gstrThreeBInvoiceList) {
      setGstrThreeBInvoiceData({
        ...gstrThreeBInvoiceData,
        ...gstrThreeBInvoiceList,
      });
    } else {
      setGstrThreeBInvoiceData({});
    }
  }, [gstrThreeBInvoiceList]);

  useEffect(() => {
    let newData = gstNumberList?.map((item: any) => {
      return {
        label: `${item?.gst_number ? item?.gst_number : ""} % ${
          item?.trade_name ? item?.trade_name : ""
        }`,
        value: item?.gst_number,
        gstIn: item?.gst_number,
        legalName: item?.legal_name,
        tradeName: item?.trade_name,
      };
    });
    if (newData?.length) {
      setGstNoList([...newData]);
    } else {
      setGstNoList([]);
    }
  }, [gstNumberList]);

  useEffect(() => {
    if (success === 1 && message === "GSTR3b Form approved successfully.") {
      dispatchResetGstModuleSuccess();
      dispatchResetMessage();
      toast.success("GSTR3b Form approved successfully.", {
        duration: 2000,
      });
      dispatchResetGstrThreeBDataList();
      const finalData = {
        token,
        clientCode: params?.id,
        branchId: branchSelected?.value,
        month: !!month.value ? month?.value : `Apr-${financialStartYear}`,
        gst_form_type: "GSTR3b",
        // gstin: gstNo?.value,
        gst_number: gstNo?.value,
      };
      branchSelected?.value
        ? delete finalData?.gst_number
        : delete finalData?.branchId;
      // setCollapseAccordian(!collapseAccordian);
      dispatchGetGstrThreeBListAction(finalData);
      setGstrThreeBInvoiceData({});
    }
  }, [message]);

  const handleGstrThreeBInvoiceListData = (type: string) => {
    if ((branchSelected?.value || gstNo?.value) && token) {
      dispatchResetGstrThreeBInvoiceList();
      const finalData = {
        token,
        clientCode: params?.id,
        branchId: branchSelected?.value,
        finacialYear: financialYear.value,
        month: !!month.value ? month?.value : `Apr-${financialStartYear}`,
        gstr3bType: type,
        gst_number: gstNo?.value,
      };
      branchSelected?.value
        ? delete finalData?.gst_number
        : delete finalData?.branchId;
      dispatchGetGstThreebInvoiceListAction(finalData);
    } else {
      setGstrThreeBInvoiceData({});
    }
  };

  const resetData = () => {
    setFinancialYear({ value: "", label: "" });
    setMonth({ value: "", label: "" });
    setBranchSelected({ value: "", label: "Select Branch" });
    setGstNo({ value: "", label: "Select GST No." });
  };

  const handleChangeInput = (data: any, name: string) => {
    if (name === "branch") {
      setBranchSelected({ ...data });
      setGstNo({ value: "", label: "Select GST No." });
    } else if (name === "fy") {
      setFinancialYear({ ...data });
    } else if (name === "month") {
      setMonth({ ...data });
    } else if (name === "gstno") {
      setGstNo({ ...data, label: data?.label?.split("%")[0] });
      setBranchSelected({ value: "", label: "Select Branch" });
    }
  };

  const handleApproval = () => {
    let monthData = month?.value?.split("-")?.[0];
    if (financialYear) {
      const finalData = {
        client_code: params?.id,
        gstin: gstNo?.value,
        financial_year: financialYear?.value,
        month: `0${
          getMonthNumber(monthData) === 0 ? "" : getMonthNumber(monthData)
        }`,
        gst_form_type: "GSTR3b",
        token,
      };
      dispatchApproveGst(finalData);
    }
  };

  const handleToggleGstCommentsModal = () => {
    setShowGstCommentsModal(!showGstCommentsModal);
  };

  const handleSubmitGstComment = (data: string) => {
    let monthData = month?.value?.split("-")?.[0];
    if (token) {
      let finalData = {
        client_code: params?.id,
        token,
        comment: data,
        gstin: gstNo?.value,
        financial_year: financialYear?.value,
        month: `0${
          getMonthNumber(monthData) === 0 ? "" : getMonthNumber(monthData)
        }`,
        gst_form_type: "GSTR3b",
      };
      dispatchPostGstCommentsAction(finalData);

      // dispatchPostAllInvoiceCommentsAction(finalData);
    }
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="Logout"
            onPress={() => {
              dispatchResetSession();
            }}
            statusCode={statusCode}
          />
        );
      } else if (error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetGstModuleError();
            }}
          />
        );
      }
    }
    if (gstCommentSuccess === 1) {
      dispatchResetCommentsSuccess();
      toast.success("Comment Added Successfully!", {
        duration: 2000,
      });
      let monthData = month?.value?.split("-")?.[0];
      if (financialYear) {
        const finalData = {
          client_code: params?.id,
          gstin: gstNo?.value,
          financial_year: financialYear?.value,
          month: `0${
            getMonthNumber(monthData) === 0 ? "" : getMonthNumber(monthData)
          }`,
          gst_form_type: "GSTR3b",
          token,
        };
        dispatchGetAllGstCommentsAction(finalData);
      }
    }
    return false;
  };

  const Option = (props: any) => {
    const { data } = props;
    return (
      <components.Option {...props}>
        <div
          className="d-flex justify-content-sm-start"
          style={{ gap: "10px" }}
        >
          <div style={{ marginTop: "-3px" }}>
            <span style={{ fontWeight: "500", fontSize: "16px" }}>
              {data?.label.split("%")[0]}
            </span>
            <br></br>
            <span style={{ color: "#6e7491" }}>
              {data?.label.split("%")[1]}
            </span>
          </div>
        </div>
      </components.Option>
    );
  };

  const handleFillGstToggle = () => {
    // setFillGstToggle(!fillGstToggle);
    history.push({
      pathname: `/gst/gstr-threeB/${params?.id}/filing`,
      state: {
        gstin: gstNo,
        clientCode: params?.id,
        financialYear: financialYear,
        month: month,
        client_code: params?.id,
        company_name,
      },
    });
  };

  let commentArray =
    gstCommentData?.comments_details?.length > 0
      ? [...gstCommentData.comments_details].reverse()
      : [];

  return (
    <>
      <div className="row">
        <div className="col-md-4 mb-3">
          <CommonHeader title="FORM GSTR-3B" />
        </div>
        <RenderHeaderCard>
          <div className="col-md-12 gst">
            <div className="header">
              Form GSTR-3B <span className="sub-heading">[See rule 61(5)]</span>
            </div>
          </div>

          <div
            className="col-md-12"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginTop: "7px",
            }}
          >
            <div
              style={{
                display: "flex",
                gap: "10px",
                justifyContent: "flex-start",
              }}
            >
              <div style={{ width: "250px" }}>
                <label htmlFor="">GST No.</label>
                <Select
                  options={gstNoList}
                  placeholder="Select GST No"
                  value={gstNo}
                  components={{ Option }}
                  onChange={(e: any) => handleChangeInput(e, "gstno")}
                />
              </div>
              <div className="d-flex align-items-center">
                <div className="mt-4">OR</div>
              </div>
              <div style={{ width: "175px" }}>
                <label htmlFor="">Branch</label>
                <Select
                  styles={customStyles}
                  placeholder="Select Branch"
                  options={branchList}
                  value={branchSelected}
                  cacheOptions
                  onChange={(e: any) => handleChangeInput(e, "branch")}
                />
              </div>

              <div style={{ width: "175px" }}>
                <label htmlFor="">Financial Year</label>
                <Select
                  styles={customStyles}
                  options={finacialYearOptions?.reverse()}
                  value={
                    !!financialYear.value
                      ? financialYear
                      : finacialYearOptions[finacialYearOptions?.length - 1]
                  }
                  onChange={(e: any) => handleChangeInput(e, "fy")}
                />
              </div>

              <div style={{ width: "175px" }}>
                <label htmlFor="">Month</label>
                <Select
                  styles={customStyles}
                  options={getMonthsOptions}
                  value={
                    !!month.value
                      ? month
                      : {
                          value: `Apr-${financialStartYear}`,
                          label: `Apr-${financialStartYear}`,
                        }
                  }
                  onChange={(e: any) => handleChangeInput(e, "month")}
                />
              </div>

              {/* {isGstFillingPresent ? (
                <div className="d-flex justify-content-center align-items-center ">
                  <button
                    className="btn btn-primary mt-4 ml-4"
                    onClick={handleFillGstToggle}
                    disabled={!gstNo?.value}
                  >
                    File GSTR-3B
                  </button>
                </div>
              ) : (
                ""
              )} */}
            </div>

            <div>
              <ButtonDropdown
                isOpen={false}
                toggle={() => {
                  setToggle(!toggle);
                }}
              >
                <DropdownToggle
                  caret
                  color="secondary"
                  style={{
                    backgroundColor: "white",
                    color: "red",
                    border: "1px solid red",
                  }}
                  outline
                  disabled
                >
                  <span className="mr-2">
                    <img src={NewDownloadIconActive} alt="Download" />
                  </span>
                  Export
                </DropdownToggle>

                <DropdownMenu style={{ width: "100%", minWidth: "130px" }}>
                  <div>Export PDF</div>
                  <div>Export EXCEL</div>
                  <div>Send to Email</div>
                </DropdownMenu>
              </ButtonDropdown>
            </div>
          </div>
          <div
            className="col-md-12 mt-2"
            style={{ color: "#7c8db0", fontWeight: 500 }}
          >
            Note: You can select either the GST number or the branch, but not
            both.
          </div>
          <div className="mt-2">
            <GstrThreeBAutoFilledTable
              data={branchSelected?.value ? branchSelected : gstNo}
              gst={gstNo?.value ? true : false}
            />
          </div>
          <MyContext.Provider
            value={{
              handleGstrThreeBInvoiceListData,
              gstrThreeBInvoiceData,
              month: month?.label ? month?.label : `Apr-${financialStartYear}`,
            }}
          >
            <GstrThreeBTable
              gstrThreeBData={gstrThreeBData}
              collapseAccordian={collapseAccordian}
            />
          </MyContext.Provider>
        </RenderHeaderCard>
      </div>
      {(isCommentPresent || isApprovalPresent) && gstNo?.value ? (
        <Approve
          handleApproval={handleApproval}
          isApprove={isApprovalPresent}
          approved={approved}
          isAddComments={isCommentPresent}
          handleToggleCommentsModal={handleToggleGstCommentsModal}
          approvalDetails={gstrThreeBData?.approval_details?.approval_details}
          approveBtnText={"Approve GSTR-3b Form"}
        />
      ) : (
        ""
      )}

      {showGstCommentsModal && (
        <CommentModal
          modal={showGstCommentsModal}
          toggleModal={handleToggleGstCommentsModal}
          data={commentData}
          commentList={commentArray}
          handlePostComment={handleSubmitGstComment}
          commentLabel="Comment"
        />
      )}

      {fetching && <Loader />}
      {handleErrorModal()}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.gst.fetching,
  error: state.gst.error,
  success: state.gst.success,
  message: state.gst.message,
  statusCode: state.gst.statusCode,
  branch: state.clientSettings.businessAddressList,
  gstrThreeBData: state.gst.gstrThreeBData,
  gstrThreeBInvoiceList: state.gst.gstrThreeBInvoiceList,
  gstCommentData: state.gst.gstCommentData,
  gstCommentSuccess: state.gst.gstCommentSuccess,
  gstNumberList: state.gst.gstNumberList,
  loginData: state.auth.loginData,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetGstModuleSuccess: () => dispatch(resetGstModuleSuccess()),
  dispatchResetGstModuleError: () => dispatch(resetGstModuleError()),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetBusinessAddressList: () => dispatch(resetBusinessAddressList()),
  dispatchGetAllBusinessAddressAction: (
    data: GetAllBussinessAddressesListPayloadType
  ) => dispatch(getAllBusinessAddressAction(data)),
  dispatchGetGstrThreeBListAction: (data: GetGstrThreeBListPayloadType) =>
    dispatch(getGstrThreeBListAction(data)),
  dispatchResetGstrThreeBDataList: () => dispatch(resetGstrThreeBDataList()),
  dispatchResetGstrThreeBInvoiceList: () =>
    dispatch(resetGstrThreeBInvoiceList()),
  dispatchGetGstThreebInvoiceListAction: (data: GstrThreeBInvoiceListPayload) =>
    dispatch(getGstThreebInvoiceListAction(data)),
  dispatchApproveGst: (data: ApproveGstPayloadType) =>
    dispatch(approveGstAction(data)),
  dispatchPostGstCommentsAction: (data: GstCommentPayloadType) =>
    dispatch(gstPostCommentAction(data)),
  dispatchGetGstNumber: (data: GetGstNumberPayload) =>
    dispatch(getGstNumberList(data)),
  dispatchResetGetGstNumber: () => dispatch(resetGstNumberList()),
  dispatchResetMessage: () => dispatch(resetGstMessage()),
  dispatchGetAllGstCommentsAction: (data: GstGetAllCommentPayloadType) =>
    dispatch(gstGetAllCommentAction(data)),
  dispatchResetCommentsSuccess: () => dispatch(resetGstCommentsSuccess()),
});

export default connect(mapStateToProps, mapDispatchToProps)(GstrThreeB);
